module.exports = __webpack_public_path__ + "img/marker-pin-01.196da6a8.svg";